<template>
    <v-app-bar
        app
        color="#1486bd"
        :clipped-left="true"
        elevation="0"
        dark
    >
      <!--v-app-bar-nav-icon v-if="appIcon" @click="drawerL"></v-app-bar-nav-icon-->

        <v-toolbar-title> <router-link class="white--text text-decoration-none" :to="selectHome">Isaac Newton</router-link></v-toolbar-title>
        <v-spacer></v-spacer>
        <p class="ml-10 my-auto mr-2 d-none d-sm-flex d-md-flex">{{usuario}}</p>
        <v-menu
            bottom
            min-width="200px"
            rounded
            offset-y
        >
            <template v-slot:activator="{ on }">
            <v-btn
                class="mr-2"
                icon
                large
                v-on="on"
            >
                <v-avatar
                size="40"
                >   
                    <v-img v-if="user.avatar != null" :src="user.avatar"></v-img>
                    <span v-else class="white--text text-h6">{{ userName }}</span>
                </v-avatar>
            </v-btn>
            </template>
            <v-card>
                <v-list-item-content class="justify-center pb-0">
                    <div class="mx-auto text-center">
                    <v-avatar
                        size="80"
                        color="#1486bd"
                    >
                        <v-img v-if="user.avatar != null" :src="user.avatar"></v-img>
                        <span v-else class="white--text text-h5">{{ userName }}</span>
                    </v-avatar>
                    <h4 class="mt-2">{{ usuario}}</h4>
                    <p class="text-body mt-1 mb-1">
                        {{ user.rol }}
                    </p>
                    <v-divider class="my-0"></v-divider>
                    
                    </div>
                </v-list-item-content>
                <!--v-list-item class="px-2">
                    <v-btn
                        class="pl-3"
                        text
                        @click.stop="changeCredentials"
                    >
                        <v-icon left color="#757575">
                            mdi-lock
                        </v-icon>
                        <p class="mb-0 text-capitalize text-body-2 font-weight-medium" style="color: #757575">Cambiar contraseña</p>
                    </v-btn>
                </v-list-item>
                <v-divider class="my-0"></v-divider-->
                <v-list-item class="px-2">
                    <v-btn
                        class="pl-0"
                        text
                        @click="logout"
                        style="width:100%; "
                    >   
                        <v-icon left color="#757575">
                            mdi-logout
                        </v-icon>
                        <p class="mb-0 text-capitalize text-body-2 font-weight-medium text-left" style="color: #757575">Cerrar sesión</p>
                    </v-btn>
                </v-list-item>
            </v-card>
        </v-menu>
    </v-app-bar>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
    components:{
	},
    data(){
        return{
            users: {
                initials: 'JD',
                fullName: 'John Doe',
                email: 'john.doe@doe.com',
            },
            userSelected: {},
            snackbar: false,
			colorSnackbar: '',
			textSnackbar: '',
        }
    },
    computed: {
        ...mapState(['user','drawer','appIcon','optionsGroup','optionsSchedule','optionsAdmin','optionsReport','optionsIngress']),
        userName(){
            return this.user.nombres.substring(0,1) + this.user.apellidos.substring(0,1);
        },
        usuario(){
            let firstName = this.user.nombres.split(' ');
            let lastName = this.user.apellidos.split(' ');
            return firstName[0] + ' ' +lastName[0];
        },
        selectHome(){
            let res = '';
            if (this.user.idRol == 1) {
                res = 'home';
            } else if (this.user.idRol == 2) {
                res = 'home-administrative';
            }
            return res;
        }
    },
    created(){

    },
    methods: {
        ...mapMutations(['setDrawer']),
        ...mapActions(['logout']),
        //changeCredentials
		notificationChange(response){
			this.notification(response.type,response.text);
		},
		deleteUserSelected(){
			this.userSelected = {};
		},
		changeCredentials(){
			this.userSelected = this.user;
			this.$refs.credentialChange.openDialog();
		},
        drawerL(){
            console.log(this.drawer);
            this.setDrawer(!this.drawer);
        },
        notification(type,text){
			this.snackbar = true;
			this.colorSnackbar = type;
			this.textSnackbar = text;
		},
    }
}
</script>

<style>

</style>